import { render, staticRenderFns } from "./MenuPhotoImporter.vue?vue&type=template&id=2667b7ba&scoped=true&"
import script from "./MenuPhotoImporter.vue?vue&type=script&lang=js&"
export * from "./MenuPhotoImporter.vue?vue&type=script&lang=js&"
import style0 from "./importer.css?vue&type=style&index=0&id=2667b7ba&scoped=true&lang=css&"
import style1 from "./MenuPhotoImporter.vue?vue&type=style&index=1&id=2667b7ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2667b7ba",
  null
  
)

export default component.exports